import { Modal, ModalProps } from "@ttc3k/trekker";
import { useEffect, useState } from "react";
import { EventWidgetEventDetails } from "shared/components";
import { EventManyQuery, EventWithOccurrences } from "gql/generated";
import type { AssetImage } from "gql/generated";
import { MultilingualLangKey } from "shared/types";
import { Locale } from "date-fns/locale";

export type DetailsSidePaneProps = ModalProps & {
  viewOnly?: boolean;
  lang?: MultilingualLangKey;
  selectedEvent: EventManyQuery["eventMany"][0] | null;
  setSelectedEvent: (event: EventManyQuery["eventMany"][0] | null) => void;
  locale?: Locale;
  eventDetailsLink?: string;
  organizationId: string;
  widgetId?: string;
  listingHeroFallbackImage?: Partial<AssetImage> | null;
};

export const DetailsSidePane = ({
  viewOnly = false,
  lang,
  selectedEvent: event,
  setSelectedEvent,
  locale,
  eventDetailsLink,
  organizationId,
  widgetId,
  listingHeroFallbackImage,
  ...rest
}: DetailsSidePaneProps) => {
  // Track the open state
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(!!event);
  }, [event, setSelectedEvent]);

  const handleCloseChange = ({ open }: { open: boolean }) => {
    if (!open) {
      setSelectedEvent(null);
    }
  };

  return (
    <Modal
      open={open}
      onOpenChange={handleCloseChange}
      closeTriggerVisual={"light"}
      {...rest}
      zIndex={"max"}
    >
      {event && (
        <EventWidgetEventDetails
          event={event as EventWithOccurrences}
          lang={lang}
          locale={locale}
          eventDetailsLink={eventDetailsLink}
          organizationId={organizationId}
          widgetId={widgetId}
          viewOnly={viewOnly}
          enableNonOperatorWarning={false}
          listingHeroFallbackImage={listingHeroFallbackImage}
        />
      )}
    </Modal>
  );
};
